export interface VentaListItem {
  idFactura: number;
  idMovimiento: number;
  serie: string | null;
  nroDocumento: number | null;
  fechaEmision: string;
  razonSocial: string | null;
  numeroIdentificacion: string | null;
  tipoComprobante: string | null;
  totalVenta: number;
  estado: string | null;
  estadoSunat: string | null;
}

export interface VentaListResult {
  items: VentaListItem[];
  totalRegistros: number;
  pagina: number;
  tamanioPagina: number;
  totalPaginas: number;
}

export interface FiltroVenta {
  fechaDesde?: string | null;
  fechaHasta?: string | null;
  idCliente?: number | null;
  idVendedor?: number | null;
  idComprobante?: number | null;
  estado?: string | null;
  serie?: string | null;
  busqueda?: string | null;
  pagina: number;
  tamanioPagina: number;
}

export const initialFiltroVenta: FiltroVenta = {
  fechaDesde: null,
  fechaHasta: null,
  idCliente: null,
  idVendedor: null,
  idComprobante: null,
  estado: null,
  serie: null,
  busqueda: null,
  pagina: 1,
  tamanioPagina: 20,
};
